import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ErrorHandler } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AppMaterialModule } from './app-material/app-material.module';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './pages/home/home.component';
import { FormsModule } from '@angular/forms';

import { OKTA_AUTH, provideOktaAuth, withOktaConfig } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AuthInterceptor } from './auth.interceptor';
import { GlobalErrorHandlerService } from './services/error-monitoring/global-error-handler.service';
import { GlobalHttpErrorInterceptor } from './services/error-monitoring/global-http-error.interceptor';
import { environment } from 'src/environments/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatIconModule } from '@angular/material/icon';
import { LdsEllipsisComponent } from './components/lds-ellipsis/lds-ellipsis.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { LoadingInterceptor } from './services/loading/loading.interceptor';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { SectionCardComponent } from './components/section-card/section-card.component';
import { StatePanelComponent } from './components/state-panel/state-panel.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { DataTableCellDirective } from './components/data-table/data-table-cell.directive';

const oktaAuth = new OktaAuth({
  issuer: environment.oktaIssuer, // "https://wexinc.oktapreview.com/oauth2/aus1h7jvzriP5gqJI0h8",
  clientId: environment.oktaClientId, // "0oa1h7jpl38MooRyX0h8",
  redirectUri: environment.oktaRedirectUri, // window.location.origin + "/login/callback", //"http://localhost:4200/login/callback",
  logoutUrl: environment.oktaLogoutUrl, // "https://wexinc.oktapreview.com",
  pkce: environment.oktaPkce,
});

@NgModule({
  declarations: [AppComponent, HomeComponent],
  bootstrap: [AppComponent],
  imports: [
    LdsEllipsisComponent,
    SkeletonComponent,
    LoadingBarComponent,
    PageHeaderComponent,
    SectionCardComponent,
    StatePanelComponent,
    DataTableComponent,
    DataTableCellDirective,
    AppMaterialModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    FontAwesomeModule,
    MatIconModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpErrorInterceptor,
      multi: true,
    },
    { provide: OktaAuth, useExisting: OKTA_AUTH },
    provideOktaAuth(withOktaConfig({ oktaAuth })),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
